import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  title = 'aalulbayt-automation-front';

  ngOnInit(): void {

//     let href = window.location.hostname;
//     if (href === 'localhost' || href === '127.0.0.1') {
//       // environment.apiUrl = 'https://stage.vidone.org/api/';
//     } else {
//       const hrefArray = href.split('.');
//       href = '';
//       for (let i = 0; i < hrefArray.length; i++) {
//         if (i === 1) {
//           href += '.api-' + hrefArray[i];
//         } else {
//           href += '.' + hrefArray[i];
//         }
//       }
//       href = href.substr(1, href.length);
//       environment.apiUrl = `https://${href}/api/v1`;
//     }

  }
}
